export const projectionInputsInitialState = {
    initialFCF: 0,
    outstandingShares: 0,
    growthRate: 10,
    discountRate: 9,
};

export function projectionInputsReducer(state, action) {
    switch (action.type) {
        case 'sync_from_sec_data':
            return {
                ...state,
                initialFCF: action.initialFreeCashFlow,
                outstandingShares: action.outstandingShares ?? 0,
            };
        case 'set_initial_fcf':
            return { ...state, initialFCF: action.value };
        case 'set_outstanding_shares':
            return { ...state, outstandingShares: action.value };
        case 'set_growth_rate':
            return { ...state, growthRate: action.value };
        case 'set_discount_rate':
            return { ...state, discountRate: action.value };
        default:
            return state;
    }
}

export const ratingInitialState = {
    result: null,
    isLoading: false,
    error: null,
    loadingMessageIndex: 0,
    loadingProgress: 0,
};

export function ratingReducer(state, action) {
    switch (action.type) {
        case 'start':
            return {
                ...state,
                isLoading: true,
                error: null,
                loadingMessageIndex: 0,
                loadingProgress: 0,
            };
        case 'success':
            return { ...state, isLoading: false, result: action.payload };
        case 'error':
            return { ...state, isLoading: false, error: action.payload };
        case 'tick_message':
            return {
                ...state,
                loadingMessageIndex: (state.loadingMessageIndex + 1) % action.messageCount,
            };
        case 'tick_progress':
            return {
                ...state,
                loadingProgress:
                    state.loadingProgress >= 90
                        ? state.loadingProgress
                        : state.loadingProgress + Math.random() * 8 + 2,
            };
        case 'complete_progress':
            return { ...state, loadingProgress: 100 };
        case 'reset_progress':
            return { ...state, loadingProgress: 0 };
        default:
            return state;
    }
}

export const usageInitialState = {
    data: null,
    isLoading: false,
    error: null,
};

export function usageReducer(state, action) {
    switch (action.type) {
        case 'clear':
            return usageInitialState;
        case 'load_start':
            return { ...state, isLoading: true, error: null };
        case 'load_success':
            return { data: action.payload, isLoading: false, error: null };
        case 'load_error':
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
}
